export const iconFontAwesomeArrowsAnglesUp = (
	<i className="fa-solid fa-angles-up"></i>
);
